import { useState } from 'react'

import { useMapDispatchToProps as useGridActions } from './useGridState'

export interface GridStateStatusState {
  isLoading: boolean
  isFetching: boolean
  isFilterMode: boolean
  isCreateMode: boolean
  gridFilterName: string
  hasGridFilterName: boolean
  isFilterSelected: boolean
}

export interface GridStateStatus {
  gridStatusState: GridStateStatusState
  gridStatusActions: GridStateStatusActions
}

export interface GridStateStatusActions {
  setLoading(val: boolean): void
  setFetching(val: boolean): void
  setFilterMode(val: boolean): void
  setCreateMode(val: boolean): void
  setGridFilterName(name: string): void
  setFilterSelected(val: boolean): void
  resetCreateFilter(): void
  resetAll(): void
}

export const useGridStatusState = (): GridStateStatus => {
  const [isLoading, setLoading] = useState<boolean>(true)
  const [isFetching, setFetching] = useState<boolean>(false)
  const [isFilterMode, setFilterMode] = useState<boolean>(false)
  const [isCreateMode, setCreateMode] = useState<boolean>(false)
  const [gridFilterName, setGridFilterName] = useState<string>('')
  const [isFilterSelected, setFilterSelected] = useState<boolean>(false)
  const { resetGridFilters: resetGridFiltersAction } = useGridActions()

  const resetCreateFilter = () => {
    setFilterMode(false)
    setCreateMode(false)
    setGridFilterName('')
  }

  const resetAll = async () => {
    setFilterSelected(false)
    resetGridFiltersAction()
    resetCreateFilter()
  }

  return {
    gridStatusState: {
      isLoading,
      isFetching,
      isFilterMode,
      isCreateMode,
      gridFilterName,
      hasGridFilterName: !!gridFilterName,
      isFilterSelected,
    },
    gridStatusActions: {
      setLoading,
      setFetching,
      setFilterMode,
      setCreateMode,
      setGridFilterName,
      setFilterSelected,
      resetCreateFilter,
      resetAll,
    },
  }
}
